export default __webpack_public_path__ + "static/media/logo.57251702.png";